import React from "react";
import Footer from "../../components/Footer";
import bookslist from "./utils/bookslist.json";
import "./bookshelf.css";
import { Colors } from "../../consts/Colors";

const BookCell = ({ book }) => {
  console.log(book);
  return (
    <div className="book">
      <img
        className="book-img"
        src={
          book.isbn
            ? `https://covers.openlibrary.org/b/isbn/${book.isbn}-M.jpg`
            : book.cover_url
        }
        alt="Cover Not Found"
      />
      <p className="book-title">{book.title}</p>
      <p className="book-author">{book.author}</p>
    </div>
  );
};

const Bookshelf = () => {
  const renderBooks = () => {
    const books = bookslist.books;
    return books.map((book) => {
      return <BookCell book={book} />;
    });
  };

  return (
    <div
      style={{
        margin: "0 auto",
        width: "auto",
        backgroundColor: Colors.primaryBg,
        paddingInline: "50px",
      }}
    >
      <h2 id="title-block-header">Bookshelf</h2>
      <div class="books-wrapper" id="books-wrapper">
        {renderBooks()}
      </div>
      <Footer />
    </div>
  );
};

export default Bookshelf;
